import { cleanupLicensePlate } from '../license-plate.service';
import { getItem, setItem } from '../storage.service';

type VehicleLike = {
    licensePlate: string;
};

type VehicleType = 'AUTO' | 'MOTR' | 'CVAN' | 'BROM';

type InsuranceLike = {
    [key in VehicleType]: {
        license_plate: string;
    };
};

const getStoredValue = async (type: VehicleType = 'AUTO') => {
    const vehicle = (await getItem('vehicle')) as VehicleLike;
    const insurance = (await getItem('insurances')) as InsuranceLike;
    return insurance?.[type]?.license_plate ?? vehicle?.licensePlate;
};

const setStoredValue = async (rawLicensePlate: string, type: VehicleType = 'AUTO') => {
    const licensePlate = cleanupLicensePlate(rawLicensePlate);
    const vehicle = (await getItem('vehicle')) as object;
    const updatedVehicle = {
        ...vehicle,
        licensePlate
    };
    await setItem('vehicle', updatedVehicle);

    const insurances = ((await getItem('insurances')) ?? { [type]: {} }) as InsuranceLike;
    await setItem('insurances', {
        ...insurances,
        [type]: {
            ...insurances[type],
            license_plate: licensePlate
        }
    });
};

const calculatePremium = async (licensePlate: string, funnelUrl: string, type: VehicleType = 'AUTO') => {
    await setStoredValue(licensePlate, type);

    window.location.href = funnelUrl;
};

export { getStoredValue, setStoredValue, calculatePremium, VehicleType };
